/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BlocksComponents from './index';

import styles from '../../../styles/blocks/blocks.scss';

const normalize = str => str.replace(/[^A-Za-z0-9]/gi, '').toLowerCase();

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string.isRequired,
    })),
    withFirst: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    items: [],
    withFirst: false,
    className: null,
};

const Blocks = ({ items, withFirst, className }) => (
    <div className={styles.container}>
        {items.map(({
            id, type, first, data,
        }) => {
            const blockKey = Object.keys(BlocksComponents).find(blockName => normalize(blockName) === normalize(type));
            const Block = BlocksComponents[blockKey] || null;
            if (Block === null) {
                return null;
            }
            return (
                <div
                    key={`block-${id}`}
                    className={classNames({
                        [styles.block]: true,
                        [styles.first]: withFirst ? first || false : false,
                        [className]: className !== null,
                    })}
                >
                    <Block first={withFirst ? first || false : false} {...data || null} />
                </div>
            );
        })}
    </div>
);

Blocks.propTypes = propTypes;
Blocks.defaultProps = defaultProps;

export default Blocks;



// WEBPACK FOOTER //
// ./js/components/blocks/Blocks.jsx